import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Utils } from '../../services/utils.service';
import { SessionService } from '../../services/session.service';
import { StoresService } from '../../services/stores.service';

@Component({
    selector: 'app-filter-products-modal',
    templateUrl: './filter-products-modal.component.html',
    styleUrls: ['./filter-products-modal.component.scss'],
    standalone: false
})
export class FilterProductsModalComponent implements OnInit {

	loader: boolean = false;
	shopMarkers: any = [];
	shops: any = [];
	shopGroups: any = [];
	statuses: any = [];
	shopMarkersCopy: any = [];
	shopGroupsCopy: any = [];
	statusesCopy: any = [];
	searchQuery: string = '';
	modalTitle: string = 'filters';
	categorySearch: string = '';
	hasCategories: boolean = false;
	hideModalTab: boolean = false;

	checked_markers: any[] = [];
	checked_shops: any[] = [];
	checked_groups: any[] = [];
	checked_statuses: any[] = [];

	treeState: { [key: string]: Map<number, { opened: boolean, children?: any[] }> } = {
		shopMarkers: new Map(),
		shopGroups: new Map()
	};

	constructor(
		private dialogRef: MatDialogRef<FilterProductsModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private sessionService: SessionService,
		private storesService: StoresService
	) {
		this.loader = !(this.data || {}).load_data;
	}

	async ngOnInit() {
		if (this.data.checked_markers) this.checked_markers = [...this.data.checked_markers];
		if (this.data.checked_shops) this.checked_shops = [...this.data.checked_shops];
		if (this.data.checked_groups) this.checked_groups = [...this.data.checked_groups];
		if (this.data.checked_statuses) this.checked_statuses = [...this.data.checked_statuses];
		if (this.data.treeState) {
			this.treeState.shopMarkers = new Map(this.data.treeState.shopMarkers || []);
			this.treeState.shopGroups = new Map(this.data.treeState.shopGroups || []);
		}
		this.hasCategories = this.sessionService.defaults.has_categories;
		const filterArray: Array<boolean> = [
			this.data['shopMarkers'] && this.data['shopMarkers'].length,
			this.data['shopGroups'] && this.data['shopGroups'].length
		];
		this.hideModalTab = ['plans'].includes(this.data.type) && filterArray.filter(item => item).length < 2;
		if (this.hideModalTab) {
			if ((this.data['shopMarkers'] && !this.data['shopMarkers'].length) &&
				(this.data['shopGroups'] && !this.data['shopGroups'].length))
				this.modalTitle = 'categories';
			else if (this.data['shopMarkers'] && !this.data['shopMarkers'].length) this.modalTitle = 'shop-group';
			else this.modalTitle = 'shop-format';
		}

		if (typeof (this.data || {}).load_data == 'function') {
			this.loader = true;
			const [shopMarkers, shopGroups, statuses] = await this.data.load_data();

			this.data.shopMarkers = shopMarkers;
			this.data.shopGroups = shopGroups;
			this.data.statuses = statuses;
		}

		if (this.data.shopMarkers) {
			this.formatData(Utils.deepCopy(this.data.shopMarkers), 'shopMarkers');
			await this.rebuildOpened('shopMarkers');
		}

		if (this.data.shops) {
			this.formatData(Utils.deepCopy(this.data.shops), 'shops');
		}

		if (this.data.shopGroups) {
			this.formatData(Utils.deepCopy(this.data.shopGroups), 'shopGroups');
			await this.rebuildOpened('shopGroups');
		}

		if (this.data.statuses) {
			this.formatData(Utils.deepCopy(this.data.statuses), 'statuses');
		}

		this.loader = false;
	}

	onNoClick(): void {
		this.saveOpened();
		this.dialogRef.close({ cancelled: true, treeState: this.getTreeState() });
	}

	cancelFilters(): void {
		this.treeState.shopMarkers.clear();
		this.treeState.shopGroups.clear();
		this.dialogRef.close({ cancelled: true, treeState: { shopMarkers: new Map(), shopGroups: new Map() } });
	}

	apply() {
		this.saveOpened();
		this.dialogRef.close({
			markers: this.checked_markers.filter(m => m),
			shops: this.checked_shops.filter(s => s),
			groups: this.checked_groups.filter(g => g),
			statuses: this.checked_statuses.filter(s => s),
			treeState: this.getTreeState()
		});
	}

	updateList(value, type) {
		console.log('UPDATE LIST', value, type);
	}

	formatData(data, type) {
		const parent: any = {
			id: -1,
			name: 'ALL',
			has_children: true,
			level: 1,
			opened: true
		};

		parent.children = this.storesService.formatChildren(data, parent);

		this[type] = [parent];

		if (type == 'shops' && this.checked_markers.length) {
			const checked = this.checked_markers.map(c => c.id);
			this.shops[0].children = this.shops[0].children.filter(shop => {
				return shop.markers.some(marker => checked.includes(marker));
			});
			if (!this.shops[0].children.length) this.shops.length = 0;
		}

		Utils.rec(this[type], e => {
			e.checked = this[type == 'shopMarkers' ? 'checked_markers' : type == 'shops' ? 'checked_shops' : type == 'shopGroups' ? 'checked_groups' : 'checked_statuses']
				.some(item => item.id == e.id && item.name == e.name);

			if (e.checked) {
				Utils.childrenCheck(e);
				Utils.parentCheck(e);
			}
		});

		return this[type];
	}

	onCheck(element: any, type: string) {
		element.checked = !element.checked;
		Utils.childrenCheck(element);
		Utils.parentCheck(element);

		// якшо вибрано "Всі"
		if (!~element.id) {
			this[type] = [];
			Utils.rec(element.children, c => {
				if (element.checked) {
					this[type].push({ id: c.id, name: c.name });
				} else {
					this[type] = this[type].filter(s => s.id != c.id);
				}
			});
			return;
		}

		const children = [];
		Utils.rec(element.children || [], c => children.push({ id: c.id, name: c.name }));
		if (element.parent) {
			Utils.recUp(element.parent, c => {
				if (c.checked && c.id !== -1) children.push({ id: c.id, name: c.name });
			});
		}

		if (!element.parent && !children.length) {
			children.push({ id: element.id, name: element.name });
		}

		if (element.parent) {
			children.push({ id: element.id || element.shop_id || element.format_id, name: element.name });
		}

		if (element.checked) {
			this[type] = this[type].concat(children);
		} else {
			this[type] = this[type].filter(s => !children.some(item => s.id == item.id && s.name == item.name));
		}
	}

	checkShops() {
		if (this.data.shops && this.data.shops.length) {
			this.search(this.searchQuery, 'shops');
			if (this.shops.length) {
				this.shops[0].checked = true;
				this.checked_shops.length = 0;
				this.shops[0].children.forEach(shop => {
					shop.checked = true;
					this.checked_shops.push({ id: shop.id, name: shop.name });
				});
				if (!this.shops[0].children.length) this.shops.length = 0;
			}
		}
	}

	async search(search: string, type) {
		this.searchQuery = search;
		if (search.length) {
			this[type] = this.findElement(this.formatData(Utils.deepCopy(this.data[type]), type)[0].children, search);
			Utils.recursiveOpened(this[type]);
		} else {
			this.formatData(Utils.deepCopy(this.data[type]), type);
		}
		await this.rebuildOpened(type);
	}

	findElement(element: any, searchQuery: string) {
		return element.filter(el => {
			if (
				Utils.searchItem(
					el,
					['name'],
					searchQuery,
					this.sessionService.personalSettings.searchAlgorithm
				)
			) {
				return el;
			} else if (el.children.some(e =>
				Utils.searchItem(
					e,
					['name'],
					searchQuery,
					this.sessionService.personalSettings.searchAlgorithm
				)
			)) {
				el.children = el.children.filter(e =>
					Utils.searchItem(
						e,
						['name'],
						searchQuery,
						this.sessionService.personalSettings.searchAlgorithm
					)
				);
				return el;
			}
		});
	}

	private saveOpened() {
		['shopMarkers', 'shopGroups'].forEach(type => {
			Utils.rec(this[type] || [], (e: any) => {
				if (e.opened) {
					const nodeState = this.treeState[type].get(e.id) || { opened: false };
					nodeState.opened = true;
					if (e.children?.length) nodeState.children = this.serializeChildren(e.children);
					this.treeState[type].set(e.id, nodeState);
				}
			});
		});
	}

	private serializeChildren(children: any[]): any[] {
		return children.map(child => ({
			id: child.id,
			name: child.name,
			has_children: child.has_children,
			level: child.level,
			opened: child.opened,
			checked: child.checked,
			...(child.children?.length && { children: this.serializeChildren(child.children) })
		}));
	}

	private getTreeState() {
		return {
			shopMarkers: Array.from(this.treeState.shopMarkers.entries()),
			shopGroups: Array.from(this.treeState.shopGroups.entries())
		};
	}

	private async rebuildOpened(type: string): Promise<void> {
		const state = this.treeState[type];
		if (!state?.size || !this[type]?.length) return;
		const checkedType = type === 'shopMarkers' ? 'checked_markers' : 'checked_groups';

		Utils.rec(this[type], (e: any) => {
			const nodeState = state.get(e.id);
			if (!nodeState?.opened) return;
			
			e.opened = true;
			if (nodeState.children?.length) {
				e.children = this.deserializeChildren(nodeState.children, e);
				Utils.rec([e], (child: any) => {
					child.checked = this[checkedType].some(item => item.id == child.id && item.name == child.name);
					if (child.checked) { Utils.childrenCheck(child); Utils.parentCheck(child); }
				});
			} else if (e.has_children && !e.children?.length && this.data.loadShopMarkerChildren && type === 'shopMarkers') {
				this.loadChildren(e, type);
			}
		});
	}

	private deserializeChildren(children: any[], parent: any): any[] {
		return children.map(child => ({
			...child,
			parent,
			...(child.children?.length && { children: this.deserializeChildren(child.children, { ...child, parent }) })
		}));
	}

	private async loadChildren(element: any, type: string): Promise<void> {
		if (element.loading || this.treeState[type].get(element.id)?.children) return;
		element.loading = true;
		try {
			const children = await this.data.loadShopMarkerChildren(element.id);
			if (children?.length) {
				children.forEach((c: any) => { c.parent = element; c.checked = false; });
				element.children = this.storesService.formatChildren(children, element);
				const nodeState = this.treeState[type].get(element.id) || { opened: true };
				nodeState.children = this.serializeChildren(element.children);
				this.treeState[type].set(element.id, nodeState);
				const checkedType = type === 'shopMarkers' ? 'checked_markers' : 'checked_groups';
				Utils.rec([element], (e: any) => {
					e.checked = this[checkedType].some(item => item.id == e.id && item.name == e.name);
					if (e.checked) { Utils.childrenCheck(e); Utils.parentCheck(e); }
				});
				await this.rebuildOpened(type);
			} else {
				element.children = [];
			}
		} catch (error) {
			element.children = [];
		} finally {
			element.loading = false;
		}
	}
}
